import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withKeys as _withKeys, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, unref as _unref, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "mt-[60px] mb-[10px]"
};
import { dateFormatter } from '@/utils/formatTime';
import { KnowledgeDocumentApi } from '@/api/ai/knowledge/document';
import { useRoute, useRouter } from 'vue-router';
import { CommonStatusEnum } from '@/utils/constants';
import { useMessage } from '@/hooks/web/useMessage';
import { onMounted, reactive, ref } from 'vue';
import KnowledgeDocumentForm from './form/index.vue';
/** AI 知识库文档 列表 */
export default /*@__PURE__*/_defineComponent({
  ...{
    name: 'KnowledgeDocument'
  },
  __name: 'index',
  props: {
    knowledgeId: {}
  },
  emits: ['document-segment-view'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const message = useMessage(); // 消息弹窗
    const route = useRoute(); // 路由
    const router = useRouter(); // 路由
    const loading = ref(true); // 列表的加载中
    const list = ref([]); // 列表的数据
    const total = ref(0); // 列表的总页数
    const queryParams = reactive({
      pageNo: 1,
      pageSize: 10,
      name: undefined,
      status: undefined,
      knowledgeId: undefined
    });
    const queryFormRef = ref(); // 搜索的表单
    /** 查询列表 */
    const getList = async () => {
      loading.value = true;
      try {
        const data = await KnowledgeDocumentApi.getKnowledgeDocumentPage(queryParams);
        list.value = data.list;
        total.value = data.total;
      } finally {
        loading.value = false;
      }
    };
    /** 搜索按钮操作 */
    const handleQuery = () => {
      queryParams.pageNo = 1;
      getList();
    };
    /** 重置按钮操作 */
    const resetQuery = () => {
      queryFormRef.value.resetFields();
      handleQuery();
    };
    /** 跳转到创建文档页面 */
    const handleCreate = () => {
      router.push({
        name: 'AiKnowledgeDocumentCreate',
        query: {
          knowledgeId: queryParams.knowledgeId
        }
      });
    };
    /** 跳转到更新文档页面 */
    const handleUpdate = id => {
      router.push({
        name: 'AiKnowledgeDocumentUpdate',
        query: {
          id,
          knowledgeId: queryParams.knowledgeId
        }
      });
    };
    /** 删除按钮操作 */
    const handleDelete = async id => {
      try {
        // 删除的二次确认
        await message.delConfirm();
        // 发起删除
        await KnowledgeDocumentApi.deleteKnowledgeDocument(id);
        message.success('删除成功');
        // 刷新列表
        await getList();
      } catch {}
    };
    /** 修改状态操作 */
    const handleStatusChange = async row => {
      try {
        // 修改状态的二次确认
        const text = row.status === CommonStatusEnum.ENABLE ? '启用' : '禁用';
        await message.confirm('确认要"' + text + '""' + row.name + '"文档吗?');
        // 发起修改状态
        await KnowledgeDocumentApi.updateKnowledgeDocumentStatus({
          id: row.id,
          status: row.status
        });
        message.success('修改成功');
        // 刷新列表
        await getList();
      } catch {
        // 取消后，进行恢复按钮
        row.status = row.status === CommonStatusEnum.ENABLE ? CommonStatusEnum.DISABLE : CommonStatusEnum.ENABLE;
      }
    };
    /** 跳转到知识库分段页面 */
    const handleSegment = doc => {
      // router.push({
      //   name: 'knowledge-segment',
      //   query: { documentId: id }
      // })
      emit('document-segment-view', doc);
    };
    /** 添加/修改操作 */
    const formRef = ref();
    const handlerAddDoc = async () => {
      formRef.value.open(props.knowledgeId, null, '添加文档');
    };
    /** 编辑角色 */
    const handlerEditDoc = async doc => {
      formRef.value.open(props.knowledgeId, doc.id, '编辑文档');
    };
    /** 初始化 **/
    onMounted(() => {
      // 如果知识库 ID 不存在，显示错误提示并关闭页面
      // if (!route.query.knowledgeId) {
      //   message.error('知识库 ID 不存在，无法查看文档列表')
      //   // 关闭当前路由，返回到知识库列表页面
      //   router.push({ name: 'AiKnowledge' })
      //   return
      // }
      // 从路由参数中获取知识库 ID
      // queryParams.knowledgeId = route.query.knowledgeId as any
      queryParams.knowledgeId = props.knowledgeId;
      getList();
    });
    return (_ctx, _cache) => {
      const _component_el_text = _resolveComponent("el-text");
      const _component_Icon = _resolveComponent("Icon");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      const _component_ContentWrap = _resolveComponent("ContentWrap");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_el_table = _resolveComponent("el-table");
      const _component_Pagination = _resolveComponent("Pagination");
      const _directive_hasPermi = _resolveDirective("hasPermi");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_ContentWrap, null, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", null, [_createVNode(_component_el_text, {
          tag: "b"
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("文档")])),
          _: 1
        })]), _createElementVNode("div", null, [_createVNode(_component_el_text, null, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("知识库的所有文件都在这里显示，整个知识库都可以通过 Chat 插件进行索引。")])),
          _: 1
        })])]), _createVNode(_component_el_form, {
          class: "flex justify-between -mb-15px",
          model: queryParams,
          ref_key: "queryFormRef",
          ref: queryFormRef,
          inline: true,
          "label-width": "68px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: queryParams.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => queryParams.name = $event),
              placeholder: "搜索",
              clearable: "",
              onKeyup: _withKeys(handleQuery, ["enter"]),
              class: "!w-240px"
            }, {
              prefix: _withCtx(() => [_createVNode(_component_Icon, {
                icon: "ep:search"
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
              type: "primary",
              onClick: handlerAddDoc
            }, {
              default: _withCtx(() => [_createVNode(_component_Icon, {
                icon: "ep:plus",
                class: "mr-5px"
              }), _cache[5] || (_cache[5] = _createTextVNode("添加文档 "))]),
              _: 1
            })), [[_directive_hasPermi, ['ai:knowledge:create']]])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }), _createVNode(_component_ContentWrap, null, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: list.value,
          stripe: true,
          "empty-text": "暂无数据",
          "show-overflow-tooltip": true
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            label: "文档编号",
            align: "center",
            prop: "id"
          }), _createVNode(_component_el_table_column, {
            label: "文件名称",
            align: "center",
            prop: "name"
          }), _createVNode(_component_el_table_column, {
            label: "字符数",
            align: "center",
            prop: "contentLength"
          }), _createVNode(_component_el_table_column, {
            label: "Token 数",
            align: "center",
            prop: "tokens"
          }), _createVNode(_component_el_table_column, {
            label: "分片最大 Token 数",
            align: "center",
            prop: "segmentMaxTokens"
          }), _createVNode(_component_el_table_column, {
            label: "召回次数",
            align: "center",
            prop: "retrievalCount"
          }), _createVNode(_component_el_table_column, {
            label: "是否启用",
            align: "center",
            prop: "status"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_switch, {
              modelValue: scope.row.status,
              "onUpdate:modelValue": $event => scope.row.status = $event,
              "active-value": 0,
              "inactive-value": 1,
              onChange: $event => handleStatusChange(scope.row)
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "上传时间",
            align: "center",
            prop: "createTime",
            formatter: _unref(dateFormatter),
            width: "180px"
          }, null, 8, ["formatter"]), _createVNode(_component_el_table_column, {
            label: "操作",
            align: "center",
            "min-width": "120px"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_button, {
              link: "",
              type: "primary",
              onClick: $event => handlerEditDoc(scope.row)
            }, {
              default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode(" 编辑 ")])),
              _: 2
            }, 1032, ["onClick"]), _createVNode(_component_el_button, {
              link: "",
              type: "primary",
              onClick: $event => handleSegment(scope.row)
            }, {
              default: _withCtx(() => _cache[7] || (_cache[7] = [_createTextVNode(" 分段 ")])),
              _: 2
            }, 1032, ["onClick"]), _createVNode(_component_el_button, {
              link: "",
              type: "danger",
              onClick: $event => handleDelete(scope.row.id)
            }, {
              default: _withCtx(() => _cache[8] || (_cache[8] = [_createTextVNode(" 删除 ")])),
              _: 2
            }, 1032, ["onClick"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["data"])), [[_directive_loading, loading.value]]), _createVNode(_component_Pagination, {
          total: total.value,
          page: queryParams.pageNo,
          "onUpdate:page": _cache[1] || (_cache[1] = $event => queryParams.pageNo = $event),
          limit: queryParams.pageSize,
          "onUpdate:limit": _cache[2] || (_cache[2] = $event => queryParams.pageSize = $event),
          onPagination: getList
        }, null, 8, ["total", "page", "limit"])]),
        _: 1
      }), _createVNode(KnowledgeDocumentForm, {
        ref_key: "formRef",
        ref: formRef,
        onOnCreate: getList
      }, null, 512)], 64);
    };
  }
});